import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../common/Footer";
import Navbar from "../common/Navbar";
import WhatsappBlueTick from "../components/service/WhatsappBlueTick";
import { Helmet } from "react-helmet";

const WhatsappBluetick = () => {
  const location = useLocation();
  useEffect(() => {
    const { search } = location;
    if (!search) {
      window.scroll(0, 0);
    }
  }, [location.pathname]);

  console.log("locationioio", location)

  return (
    <> <Helmet>
      <meta name="keywords" content="whatsapp blue tick,blue tick verification,whatsapp marketing company,advertising on WhatsApp,whatsapp marketing service,whatsapp marketing agency
    "/>
      <title>WhatsApp Blue Tick for Official Business Trust</title>
      <meta
        name="description"
        content="Get verified with WhatsApp Blue Tick and build instant trust with customers. Official approval support, fast process, and expert guidance. Apply now!"
      />
    </Helmet>
      <div>
        <Navbar />
        <WhatsappBlueTick />
        <Footer />
      </div>
    </>

  );
};

export default WhatsappBluetick;
